import React, { useEffect } from "react";
import { Stepper } from "@shared/components/Stepper";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { useToast } from "@shared/hooks/use-toast";
import SelectRecords from "./steps/SelectRecords";
import ChoseFields from "./steps/ChoseFields";
import SetValues from "./steps/SetValues";
import Review from "./steps/Review";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

const BulkEditPlanStepper: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { toast } = useToast();
  const navigate = useNavigate();
  const storageKey = `plan-bulkedit-stepper-${remoteUtilityId}`;

  // Clear data when navigating away from this component (unmount)
  useEffect(() => {
    return () => {
      localStorage.removeItem(storageKey);
    };
  }, [storageKey]);

  const handleComplete = async (allStepData: any) => {
    toast({
      title: "Bulk Edit Completed Successfully",
    });

    navigate("/plan-tarrif/plan-tarrif-landing?tab=plans");
  };

  const stepperSteps = [
    {
      id: "select-records",
      title: "Select Records",
      component: <SelectRecords/>,
      slug: "select-records",
    },
    {
      id: "choose-fields",
      title: "Choose Fields",
      component: <ChoseFields data={undefined} onDataChange={undefined as any} onNext={undefined as any} />,
      slug: "choose-fields",
    },
    {
      id: "set-values",
      title: "Set Values",
      component: <SetValues data={undefined} onDataChange={undefined as any} onNext={undefined as any} />,
      slug: "set-values",
    },
    {
      id: "review",
      title: "Review",
      component: <Review />,
      slug: "review",
    },
  ];

  return (
    <div className="">
      <div className="mb-6 flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/plan-tarrif/plan-tarrif-landing?tab=plans")}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>

        <PageHeader
          title="Bulk Edit Plan"
          subtitle="Edit multiple plans."
        />
      </div>

      <Stepper
        storageKey={storageKey}
        steps={stepperSteps}
        onComplete={handleComplete}
        persistProgress={true}
        onStepChange={() => {}}
        onValidation={() => {}}
        onStepSave={async () => {}}
      />
    </div>
  );
};

export default BulkEditPlanStepper;
